export default __webpack_public_path__ + "static/media/wrong_answer.fadd2b99.svg";